import { Box, Typography } from '@mui/material';
import TicketBlock from './creation/cashdesk/TicketBlock';
import useTicketPointer from './creation/cashdesk/useTicketPointer';
import { CANVAS_HEIGHT, CANVAS_WIDTH, CashdeskBlock } from './creation/cashdesk/cashdeskBlocks';

interface CashdeskTicketPreviewProps {
  blocks: CashdeskBlock[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  onUpdateBlock: (id: string, patch: Partial<CashdeskBlock>) => void;
  onRemoveBlock: (id: string) => void;
}

function CashdeskTicketPreview({ blocks, selectedId, onSelect, onUpdateBlock, onRemoveBlock }: CashdeskTicketPreviewProps) {
  const pointer = useTicketPointer(blocks, onUpdateBlock);

  return (
    <Box>
      <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: 'block', mb: 0.75, fontSize: '0.7rem', letterSpacing: 0.5, textTransform: 'uppercase' }}>
        Aperçu du ticket
      </Typography>
      <Box
        sx={{
          width: CANVAS_WIDTH,
          height: CANVAS_HEIGHT,
          // Rendu du ticket imprimé : couleurs fixes
          border: '1.5px solid #495057',
          position: 'relative',
          backgroundColor: '#fff',
          overflow: 'hidden',
          cursor: 'default',
          userSelect: 'none',
          touchAction: 'none',
        }}
        onClick={() => onSelect(null)}
        onPointerMove={pointer.onPointerMove}
        onPointerUp={pointer.onPointerUp}
      >
        {blocks.map(block => (
          <TicketBlock
            key={block.id}
            block={block}
            selected={selectedId === block.id}
            onMoveStart={e => {
              onSelect(block.id);
              pointer.start('move', e, block);
            }}
            onResizeStart={e => pointer.start('resize', e, block)}
            onUpdate={patch => onUpdateBlock(block.id, patch)}
            onRemove={() => onRemoveBlock(block.id)}
          />
        ))}
      </Box>
    </Box>
  );
}

export default CashdeskTicketPreview;
